<div id="sidenav">
  <div class="sidenav-header">
    <br />
    <div *ngIf="!isMenuOpen && requestsCompleted">
      <mat-icon color="primary" (click)="onToolbarMenuToggle()" style="cursor: pointer; padding-left: 8%;display: contents">double_arrow</mat-icon>
    </div>
    <div *ngIf="isMenuOpen && requestsCompleted">
      <div class="flex items-center justify-between">
        <h5 class="app-side-title" [innerHTML]="appName"></h5>
        <mat-icon matRipple color="primary" (click)="onToolbarMenuToggle()" style="transform: rotate(180deg); cursor: pointer; margin-right: 0.5rem">double_arrow</mat-icon>
      </div>
      <br />
      <div *ngIf="requestsCompleted">
        <mat-select class="programs-select" (selectionChange)="updateNavigation()" [(value)]="selectedComponent">
          <mat-option value="site" *ngIf="navComponents.includes('site')">Site Configuration</mat-option>
          <mat-option value="program" *ngIf="navComponents.includes('program')">Grid Services Programs</mat-option>
          <mat-option value="control" *ngIf="navComponents.includes('control')">Site Schedules</mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div *ngIf="!requestsCompleted" class="flex items-center justify-center">
    <app-calibrant-load [small]="true"></app-calibrant-load>
  </div>
  <div class="flex flex-col justify-start sidenav-body" *ngIf="isMenuOpen && requestsCompleted">
    <div class='table-container' [style.height]="treeHeight" *ngIf="selectedComponent != 'control'">

      <tree-display *ngIf="selectedComponent == 'site' && sites.length > 0"
                    [labelIdentifier]=displayProperty
                    [treeData]="TREE_DATA"
                    [showSearch]=showSearch
                    [searchProperties]="['name']"
                    [showControls]=showControls
                    [iconIdentifier]="'icon'"
                    [selectedNodes]="selectedSiteNodes"
                    [hideIrrelevant]='true'
                    [iconDefinitions]=iconMap
                    [placeholderDefinitions]="placeholderNodeDefinitions"
                    [expandedNodes]="expandedNodes"
                    (selection$)="selectNode($event)"
      >
      </tree-display>

      <tree-display *ngIf="selectedComponent == 'program' && programs.length > 0"
                    [labelIdentifier]=displayProperty
                    [treeData]="programs"
                    [searchProperties]="['name']"
                    [showSearch]=showSearch
                    [selectedNodes]="selectedProgramNodes"
                    [hideIrrelevant]='true'
                    [showControls]=showControls
                    (selection$)="selectNode($event)"
      >
      </tree-display>
    </div>
    <mat-nav-list *ngIf="selectedComponent == 'control'">
      <a mat-list-item routerLink="/control/home">
        <mat-icon class="mat-icon-rtl-mirror" *ngIf="isControlSelected()">
          subdirectory_arrow_right
        </mat-icon>
        Site Schedules
      </a>
    </mat-nav-list>
  </div>
</div>
